import React, { memo, useEffect } from "react";
import { Button, useMutation, useNotify } from "react-admin";
import { useForm } from "react-final-form";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";

interface CalculationButtonProps {
  invalid: boolean;
  setResultCalculations: any;
  setIsLoaded: (isLoaded: boolean) => void;
  setIsCalculationButtonClicked: (isLoaded: boolean) => void;
  formData: formCreateStudent;
}

const CalculationButton = ({
  invalid,
  setResultCalculations,
  setIsLoaded,
  setIsCalculationButtonClicked,
  formData,
}: CalculationButtonProps) => {
  const notify = useNotify();
  const formValues = useForm().getState().values;

  useEffect(() => {
    setIsLoaded(false);
    setIsCalculationButtonClicked(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  const [HandleCalculationCost, { loading }] = useMutation(
    {
      type: "create",
      resource: "CostPreview/registerStudent",
      payload: {
        data: {
          parentId: formValues.parentId,
          schoolId: formValues.schoolId,
          levelId: formValues.levelId,
          levelGroupId: formValues.levelGroupId
            ? formValues.levelGroupId
            : null,
          firstName: formValues.firstName,
          lastName: formValues.lastName,
          gender: formValues.gender,
          macAddress: formValues.macAddress ? formValues.macAddress : null,
          dateOfBirth: formValues.dateOfBirth,
          status: "active",
          uniqueCode: formValues.uniqueCode,
          studentSchedule: {
            academicYearId: formValues.academicYearId,
            startedAt: formValues.date,
            isTaking: true,
            detail: {
              lat: formValues.locationData?.LATITUDE,
              lng: formValues.locationData?.LONGITUDE,
              street: formValues.street,
              unitNumber: formValues.unitNumber ? formValues.unitNumber : null,
              blockNumber: formValues.blockNumber,
              postalCode: formValues.postalCode,
              building: formValues.building,
              isMonday: formValues.isMonday ? true : false,
              isTuesday: formValues.isTuesday ? true : false,
              isWednesday: formValues.isWednesday ? true : false,
              isThursday: formValues.isThursday ? true : false,
              isFriday: formValues.isFriday ? true : false,
              isFromSchool:
                formValues.wayType === "OneWayMorning" ? false : true,
              isToSchool:
                formValues.wayType === "OneWayAfternoon" ? false : true,
            },
          },
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        setResultCalculations(res.json);
        setIsLoaded(true);
        setIsCalculationButtonClicked(true);
      },
      onFailure: (error) => {
        notify(`Failed Calculation Cost, error: ${error.message}`, "warning");
        setResultCalculations([]);
      },
    }
  );

  const CalculationCostButtonStyle = {
    padding: "7px 16px",
  };

  return (
    <Button
      label={loading ? `Loading...` : `Calculation Cost`}
      style={CalculationCostButtonStyle}
      onClick={HandleCalculationCost}
      disabled={invalid}
    >
      <MonetizationOnIcon />
    </Button>
  );
};

export default memo(CalculationButton);
